<!-- @veltra/icons generated sha256:f854bb4a31875425 gen:8 source:src/svg/normal/form-number-range-input.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormNumberRangeInput' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="6"
      height="8"
      x="1"
      y="4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <rect
      width="6"
      height="8"
      x="9"
      y="4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="M7.5 8h1m-5.3-.8.8-.7V10m9-2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0V10"
    />
  </svg>
</template>
